"use strict";
// Copyright © 2021 Move Closer
Object.defineProperty(exports, "__esModule", { value: true });
exports.teaserBoxInnerGrids = void 0;
const _1XL_1 = require("./1XL");
const _2L_1 = require("./2L");
const _6S_big_thumbnails_list_1 = require("./6S-big-thumbnails-list");
const _6S_text_list_1 = require("./6S-text-list");
const _6S_thumbnails_list_1 = require("./6S-thumbnails-list");
const _6T_text_list_1 = require("./6T-text-list");
const _8S_1 = require("./8S");
const _4S_1 = require("./4S");
const _8T_1 = require("./8T");
const L_2S_big_thumbnails_list_1 = require("./L-2S-big-thumbnails-list");
const L_2S_text_list_1 = require("./L-2S-text-list");
const L_2S_thumbnails_list_1 = require("./L-2S-thumbnails-list");
const L_4S_1 = require("./L-4S");
const L_8S_1 = require("./L-8S");
const L_5S_text_list_1 = require("./L-5S-text-list");
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
exports.teaserBoxInnerGrids = [
    _1XL_1.TeaserBoxInnerGrid1XL,
    _2L_1.TeaserBoxInnerGrid2L,
    _6S_big_thumbnails_list_1.TeaserBoxInnerGrid6SBigThumbnailsList,
    _6S_text_list_1.TeaserBoxInnerGrid6STextList,
    _6S_thumbnails_list_1.TeaserBoxInnerGrid6SThumbnailsList,
    _6T_text_list_1.TeaserBoxInnerGrid6TTextList,
    _8S_1.TeaserBoxInnerGrid8S,
    _4S_1.TeaserBoxInnerGrid4S,
    _8T_1.TeaserBoxInnerGrid8T,
    L_2S_big_thumbnails_list_1.TeaserBoxInnerGridL2SBigThumbnailsList,
    L_2S_text_list_1.TeaserBoxInnerGridL2STextList,
    L_2S_thumbnails_list_1.TeaserBoxInnerGridL2SThumbnailsList,
    L_4S_1.TeaserBoxInnerGridL4S,
    L_8S_1.TeaserBoxInnerGridL8S,
    L_5S_text_list_1.TeaserBoxInnerGridL5STextList
];
//# sourceMappingURL=index.js.map